import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import './scss/global.scss'

const container = document.getElementById('page-root')
const root = createRoot(container as HTMLElement)
root.render(
  <Router>
    <App />
  </Router>,
)
